import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectLanguageComponent } from './components/select-language/select-language.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    SelectLanguageComponent,
  ],
  declarations: [ 
    SelectLanguageComponent
  ]
  
})
export class LanguageModule { }



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/language/language.module.ts